import { useContext, useEffect, useRef } from 'react';
import { UNSAFE_NavigationContext } from 'react-router-dom';
import Swal from 'sweetalert2';

const askForExitAction = () => Swal.fire({
  title: 'Cambios sin guardar',
  text: 'Puedes guardar el producto como borrador antes de salir.',
  icon: 'warning',
  showCancelButton: true,
  showDenyButton: true,
  confirmButtonText: 'Guardar borrador',
  denyButtonText: 'Descartar',
  cancelButtonText: 'Cancelar',
  allowOutsideClick: false,
  allowEscapeKey: false
});

export const resolveProductExit = async (result, saveDraft) => {
  if (result.isConfirmed)
    return Boolean(await saveDraft());

  return Boolean(result.isDenied);
};

export const useProductExitGuard = ({
  dirty,
  skipPromptRef,
  saveDraft
}) => {
  const { navigator } = useContext(UNSAFE_NavigationContext);
  const saveDraftRef = useRef(saveDraft);
  const showingPromptRef = useRef(false);

  saveDraftRef.current = saveDraft;

  useEffect(() => {
    if (!dirty || !navigator.block)
      return undefined;

    const unblock = navigator.block(async transition => {
      if (skipPromptRef.current) {
        unblock();
        transition.retry();
        return;
      }

      if (showingPromptRef.current)
        return;

      showingPromptRef.current = true;
      const result = await askForExitAction();
      const canExit = await resolveProductExit(
        result,
        saveDraftRef.current
      );
      showingPromptRef.current = false;

      if (!canExit)
        return;

      skipPromptRef.current = true;
      unblock();
      transition.retry();
    });

    return unblock;
  }, [dirty, navigator, skipPromptRef]);
};
